import $ from 'jquery';
import * as Utils from 'lib/utils';

const W = window;
const D = document;

if (!$.events) $.events = { ui: [], auth: [] };

$.onAuth = $.fn.onAuth = function (handler) {
  $.events.auth.push([this, handler]);
  return this;
};

$.setAuth = async auth => {
  W.AUTH = Utils.freeze(auth);
};

$.initAuth = async () => {
  $.setAuth($.unpack(W.AUTH));

  const perms = W.AUTH?.user?.permissions || {};
  const website = W.AUTH.website;
  const settings = {
    website: website.settings || {},
    user: W.AUTH?.user,
  };

  console.groupCollapsed('🔑 AUTH');
  console.log('API', W.API);
  console.log('AUTH', W.AUTH);
  console.log('PERMS', perms);
  console.log('SETTINGS', settings);
  console.groupEnd();

  $.hasSettings = rules => {
    if (rules === '*') return true;

    if (Utils.isString(rules))
      rules = rules
        .split(',')
        .map(rule => rule.trim())
        .filter(Boolean);

    if (Utils.isArray(rules) && rules.length) {
      for (const rule of rules) {
        const perm = Utils.get(settings, rule);
        if (!perm) return false;
      }

      return true;
    }

    return false;
  };

  $.hasPerms = rules => {
    if (rules === '*') return true;

    if (perms === true) return true;

    if (Utils.isString(rules))
      rules = rules
        .split(',')
        .map(rule => rule.trim())
        .filter(Boolean);

    if (Utils.isArray(rules) && rules.length) {
      for (const rule of rules) {
        const perm = Utils.get(perms, rule);
        if (!perm) return false;
      }

      return true;
    }

    return false;
  };

  $.hasAnyPerms = rules => {
    if (rules === '*') return true;

    if (perms === true) return true;

    if (Utils.isString(rules))
      rules = rules
        .split(',')
        .map(rule => rule.trim())
        .filter(Boolean);

    if (Utils.isArray(rules) && rules.length) {
      for (const rule of rules) {
        const perm = Utils.get(perms, rule);
        if (perm) return true;
      }
    }

    return false;
  };

  $.hasWebsitePerms = rules => {
    if (rules === '*') return true;

    if (Utils.isString(rules))
      rules = rules
        .split(',')
        .map(rule => rule.trim())
        .filter(Boolean);

    if (Utils.isArray(rules) && rules.length) {
      for (const rule of rules) {
        const websitePerm = Utils.get(W.AUTH.website, rule);
        if (websitePerm) return true;
      }
    }

    return false;
  };

  $.fn.applyPerms = function () {
    this.each(function () {
      const $obj = $(this);

      // TODO: The following Code removes the container element, will need to be tweaked

      $obj.find('[data-perms-remove]').each((idx, item) => {
        const $item = $(item);
        const rules = $item.data('perms-remove');
        if (!$.hasPerms(rules)) $item.remove();
      });

      $obj
        .find('[data-website-perms-visible]')
        .add(this)
        .each((idx, item) => {
          const $item = $(item);
          const rules = $item.data('website-perms-visible');
          if ($.hasWebsitePerms(rules)) {
            $item.removeAttr('data-website-perms-visible');
          }
        });

      $obj
        .find('[data-perms-visible]')
        .add(this)
        .each((idx, item) => {
          const $item = $(item);
          const rules = $item.data('perms-visible');

          if ($.hasPerms(rules)) $item.removeAttr('data-perms-visible');
        });

      $obj
        .find('[data-perms-hidden]')
        .add(this)
        .each((idx, item) => {
          const $item = $(item);
          const rules = $item.data('perms-hidden');

          if (!$.hasPerms(rules)) $item.removeAttr('data-perms-hidden');
        });

      $obj
        .find('[data-perms-any-visible]')
        .add(this)
        .each((idx, item) => {
          const $item = $(item);
          const rules = $item.data('perms-any-visible');

          if ($.hasAnyPerms(rules)) $item.removeAttr('data-perms-any-visible');
        });

      $obj
        .find('[data-perms-any-hidden]')
        .add(this)
        .each((idx, item) => {
          const $item = $(item);
          const rules = $item.data('perms-any-hidden');

          if (!$.hasAnyPerms(rules)) $item.removeAttr('data-perms-hidden');
        });

      $obj
        .find('[data-perms-editable]')
        .add(this)
        .each((idx, item) => {
          const $item = $(item);
          const rules = $item.data('perms-editable');
          const $editor = $item.data('editor');

          $item.prop('disabled', !$.hasPerms(rules)).toggleClass('disabled', !$.hasPerms(rules));
          if ($editor) $editor.enable($.hasPerms(rules));
          // TODO probably needs tweaks for other UI elements
        });

      $obj
        .find('[data-perms-any-editable]')
        .add(this)
        .each((idx, item) => {
          const $item = $(item);
          const rules = $item.data('perms-any-editable');
          const $editor = $item.data('editor');

          $item.prop('disabled', !$.hasAnyPerms(rules)).toggleClass('disabled', !$.hasAnyPerms(rules));
          if ($editor) $editor.enable($.hasPerms(rules));
          // TODO probably needs tweaks for other UI elements
        });

      $obj
        .find('[data-settings-visible]')
        .add(this)
        .each((idx, item) => {
          const $item = $(item);
          const rules = $item.data('settings-visible');

          if ($.hasSettings(rules)) $item.removeAttr('data-settings-visible');
        });

      $obj.find('[data-settings-remove]').each((idx, item) => {
        const $item = $(item);
        const rules = $item.data('settings');
        if (!$.hasSettings(rules)) $item.remove();
      });

      $obj.find('[data-website-remove-for-licensees]').each((idx, item) => {
        const $item = $(item);
        const remove_for_licensees = $item.data('website-remove-for-licensees');

        if (website.is_licensee && Utils.toBoolean(remove_for_licensees)) $item.remove();
      });

      $obj.find('[data-website-remove]').each((idx, item) => {
        const $item = $(item);
        const website_id = $item.data('website-remove');

        if (Array.isArray(website_id)) {
          if (website_id.includes(website.id)) $item.remove();
        } else if (website.id === Utils.toInt(website_id)) $item.remove();
      });
    });

    return this;
  };

  $('.apply-perms').applyPerms();
};
